module.exports = __webpack_public_path__ + "static/podcast-o-aplikaci-springaudit-d9e8363ee794b4d93e159579b63f213a.jpg";